import { useEffect, useState, useCallback } from 'react';

const useTelegram = () => {
  const [tg, setTg] = useState(null);
  const [user, setUser] = useState(null);
  const [initData, setInitData] = useState('');
  const [colorScheme, setColorScheme] = useState('light');

  useEffect(() => {
    // Initialize Telegram WebApp
    const telegram = window.Telegram?.WebApp;

    if (telegram) {
      telegram.ready();
      telegram.expand();

      setTg(telegram);
      setUser(telegram.initDataUnsafe?.user || null);
      setInitData(telegram.initData || '');
      setColorScheme(telegram.colorScheme || 'light');

      // Apply Telegram theme colors
      document.documentElement.style.setProperty('--tg-theme-bg-color', telegram.themeParams.bg_color || '#ffffff');
      document.documentElement.style.setProperty('--tg-theme-text-color', telegram.themeParams.text_color || '#000000');
      document.documentElement.style.setProperty('--tg-theme-hint-color', telegram.themeParams.hint_color || '#999999');
      document.documentElement.style.setProperty('--tg-theme-link-color', telegram.themeParams.link_color || '#2481cc');
      document.documentElement.style.setProperty('--tg-theme-button-color', telegram.themeParams.button_color || '#2481cc');
      document.documentElement.style.setProperty('--tg-theme-button-text-color', telegram.themeParams.button_text_color || '#ffffff');
    }
  }, []);

  const onClose = useCallback(() => {
    try { tg?.close(); } catch (e) { console.warn(e); }
  }, [tg]);

  const showMainButton = useCallback((text, onClick) => {
    try {
      if (tg && tg.MainButton) {
        tg.MainButton.text = text;
        tg.MainButton.show();
        if (onClick) tg.MainButton.onClick(onClick);
      }
    } catch (e) { console.warn('Telegram MainButton error:', e); }
  }, [tg]);

  const hideMainButton = useCallback((onClick) => {
    try {
      if (tg && tg.MainButton) {
        tg.MainButton.hide();
        if (onClick) tg.MainButton.offClick(onClick);
      }
    } catch (e) { console.warn('Telegram MainButton error:', e); }
  }, [tg]);

  const showBackButton = useCallback((onClick) => {
    try {
      if (tg && tg.BackButton) {
        tg.BackButton.show();
        if (onClick) tg.BackButton.onClick(onClick);
      }
    } catch (e) { console.warn(e); }
  }, [tg]);

  const hideBackButton = useCallback((onClick) => {
    try {
      if (tg && tg.BackButton) {
        tg.BackButton.hide();
        if (onClick) tg.BackButton.offClick(onClick);
      }
    } catch (e) { console.warn(e); }
  }, [tg]);

  const showAlert = useCallback((message) => {
    try { tg?.showAlert(message); } catch (e) { console.warn(e); }
  }, [tg]);

  const showConfirm = useCallback((message, callback) => {
    try { tg?.showConfirm(message, callback); } catch (e) { console.warn(e); }
  }, [tg]);

  const showPopup = useCallback((params, callback) => {
    try { tg?.showPopup(params, callback); } catch (e) { console.warn(e); }
  }, [tg]);

  const hapticFeedback = useCallback((type = 'impact', style = 'medium') => {
    try {
      if (type === 'impact') {
        tg?.HapticFeedback?.impactOccurred(style);
      } else if (type === 'notification') {
        tg?.HapticFeedback?.notificationOccurred(style);
      } else if (type === 'selection') {
        tg?.HapticFeedback?.selectionChanged();
      }
    } catch (e) { console.warn(e); }
  }, [tg]);

  return {
    tg,
    user,
    initData,
    colorScheme,
    onClose,
    showMainButton,
    hideMainButton,
    showBackButton,
    hideBackButton,
    showAlert,
    showConfirm,
    showPopup,
    hapticFeedback,
  };
};

export default useTelegram;
